export enum EnumParticipantMode {
    User = 'User',
    Team = 'Team',
    UserTeam = 'UserTeam'
}